export class IncidentsDashboardDataModel {
    // public incidentsDashboardModels: Array<IncidentDashboardModels>;
    public pivotDefectsClass: Array<PivotDefectsClass>;
    public pivotIncidence: Array<PivotIncidence>;
    public pivotDefectMode: Array<PivotDefectMode>;
    public defectCost: Array<DefectCost>;
    public incidenetDashboardPoints: IncidenetDashboardPoint;
}

export class IncidentsDashboardChartsDataModel {
    public pivotDefectsClass: Array<PivotDefectsClass>;
    public pivotIncidence: Array<PivotIncidence>;
    public pivotDefectMode: Array<PivotDefectMode>;
    public defectCost: Array<DefectCost>;
    public incidenetDashboardPoints: IncidenetDashboardPoint;
}

export class DefectCost {
    public categoryid: string;
    public totaldefectcostpercategory: number;
}

export class DefectCostUI {
    public categoryid: string;
    public totaldefectcostpercategory: string;
}
export class IncidenetDashboardPoint {
    public man: number;
    public machine: number;
    public method: number;
    public material: number;
    public act: number;
    public check: number;
    public do: number;
    public notStarted: number;
    public plan: number;
    public done: number;
}
export class IncidentDashboardModels {
    public productdescription: string;
    public defectmodeaggregation: string;
    public leveL0: string;
    public leveL4: string;
    public defectseveritygrade: string;
    public productionline: string;
    public totaldefectcost: number;
    public defectpriorityindex: number;
    public dpidefectclass: string;
}

export class PivotDefectsClass {
    public dpidefectclass: string;
    public count: number;
}

export class PivotIncidence {
    public leveL0: string;
    public count: number;
}
export class PivotDefectMode {
    public defectmodeaggregation: string;
    public leveL0: string;
    public fourms: string;
    public recordid: string;
    public productionline: string;
    public defectpriorityindex: number;
    public dpidefectclass: string;
    public defectseveritygrade: string;
    public pdcastatus: string;
    public occurances: number;
    public agreement: string;
    public remarks: string;
    public subregion: string;
    public sites: string;
    public businessgroup: string;
}

export class CurrencyList {
    public cluster: string;
    public country: string;
    public euroexchangerate: number;
    public currencyunit: string;
    public currencycode: string;
    public site: string;
}

export class PivotTableAgreement {
    public fromDate: string;
    public toDate: string;
    public cluster: string[];
    public bigcategory: string[];
    public site: string[];
    public dataDetails: Array<PivotDefectMode>;
}

export class PivotTableDetails {
    public createddate: string;
    public startdate: string;
    public enddate: string;
    public subregion: string;
    public sites: string;
    public businessgroup: string;
    public defectmodeaggregation: string;
    public leveL0: string;
    public fourms: string;
    // public product: string;
    public recordid: string;
    public productionline: string;
    public defectpriorityindex: number;
    public occurances: number;
    public defectseveritygrade: string;
    public dpidefectclass: string;
    public pdcastatus: string;
    public agreement: string;
    public remarks: string;
    public createdby: string;
}

export class PivotTableDataModel {
    public pivotTableAgreement: Array<PivotTableDetails>;
}

export class DeleteIncidentDataModel {
    public Id: number[];
    public fileName: string;
}

export class DeletedHistoryModel {
    public filenames: string;
    public recordcount: string;
    public deleteddate: string;
    public deletedby: string;
}

export class IncidentData {
    public id: number;
    public incidentfileid: number;
    public productiondate: string;
    public productcode: string;
    public productdescription: string;
    public cluster: string;
    public defectmodeaggregation: string;
    public bigcategory: string;
    public subcategory: string;
    public recordid: string;
    public formatsize: string;
    public losstree: string;
    public leveL0: string;
    public leveL1: string;
    public leveL2: string;
    public leveL3: string;
    public leveL4: string;
    public leveL5: string;
    public defectseveritygrade: string;
    public productionline: string;
    public noofblockedproduct: string;
    public averagebatchqty: string;
    public uom: string;
    public affectedproductpercentage: string;
    public frequencyscore: string;
    public processpoint: string;
    public fourms: string;
    public detectionpoint: string;
    public detectability: string;
    public eincident: string;
    public rework: string;
    public ambercrqs: string;
    public qualityrelatedwaste: string;
    public dincidents: string;
    public palletnonconformance: string;
    public customernonconformance: string;
    public onshelfcrqs: string;
    public consumercomplaints: string;
    public marketplaceincident: string;
    public costof1pc: string;
    public totaldefectcost: string;
    public totalcostpercentage: string;
    public costscore: string;
    public detectabilityindex: string;
    public severityindex: string;
    public frequencyindex: string;
    public costindex: string;
    public defectpriorityindex: string;
    public dpivstotaldpipercentage: string;
    public cummulativedpi: string;
    public dpidefectclass: string;
    public man: string;
    public machine: string;
    public method: string;
    public material: string;
    public pdcastatus: string;
    public sites: string;
    public localcurrency: string;
    public totaldefectcosteuro: string;
    public filenames: string;
    public uploadedDate: string;
    public uploadedBy: string;
    public isselected: boolean;
}
